import React, { useState } from 'react';
import './Admin.css';

function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simple password for MVP - upgrade to Firebase Auth later
    if (password === 'monaco@buddy*JACUZZI6sampling') {
      onLogin();
    } else {
      setError('Incorrect password');
    }
  };

  return (
    <div className="admin-login-container">
      <div className="login-box">
        <h1>Admin Login</h1>
        <p>SMPW Masters Event</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
            />
          </div>
          
          <button type="submit" className="btn btn-primary">Login</button>
          <a href="/" className="back-link">← Back to Home</a>
        </form>
        
        <div className="password-hint">
          <small>Contact the administrator for the password.</small>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
